import { useGetManyReference } from "react-admin";
import { FieldValues, Path } from "react-hook-form";
import { Instructor } from "../providers/instructorsProvider";
import { SelectInput } from "./SelectInput";
import { SxProps } from "@mui/material";
import { useAutovioContext } from "../hooks/useAutovioContext";
import { useMemo } from "react";

interface LecturerInputProps {
  source: Path<FieldValues>;
  bulkEdit?: boolean;
  fullWidth?: boolean;
  size?: "small";
  helperText?: string;
  sx?: SxProps;
}

export const LecturerInput = (props: LecturerInputProps) => {
  const [{ drivingSchoolId }] = useAutovioContext();
  const { data: instructors } = useGetManyReference<Instructor>("instructors", {
    target: "drivingSchoolId",
    id: drivingSchoolId,
    sort: { field: "name", order: "ASC" },
    pagination: { page: 1, perPage: 999 },
    filter: { isActive: true },
  });
  const options = useMemo((): Array<[string, string]> => {
    if (!instructors) {
      return [];
    }
    return [
      ["", ""],
      ...instructors.map((instructor): [string, string] => [instructor.autovioUserId, instructor.name]),
    ];
  }, [instructors]);
  return <SelectInput label="Dozent" options={options} {...props} />;
};
